import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import ProjectKpiCenter from "@/components/app/ProjectKpiCenter";
import { ChartLineUp, ArrowRight } from "@phosphor-icons/react";
import { PanelHeader } from "./_shared";

export default function KPIPanel({ project }) {
  const [kpi, setKpi] = useState(null);
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data } = await api.get(`/projects/${project.id}/kpi`);
        if (alive) setKpi(data);
      } catch (e) { if (alive) setErr(formatApiError(e)); }
      finally { if (alive) setLoading(false); }
    })();
    return () => { alive = false; };
  }, [project.id]);
  return (
    <div data-testid={`panel-kpi-${project.id}`}>
      <PanelHeader icon={ChartLineUp} title="Project KPI Snapshot" subtitle="Schedule · cost · quality · stakeholder"
        action={<ProjectKpiCenter project={project} trigger={<Button size="sm" variant="outline">Full center <ArrowRight size={11} className="ml-1" /></Button>} />} />
      {loading && <div className="text-[11px] text-slate-500">Loading…</div>}
      {err && <div className="rounded-md border border-amber-200 bg-amber-50/60 px-2 py-1.5 text-[11px] text-amber-800">{err}</div>}
      {kpi && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
          {[
            ["Progress",       `${kpi.progress_pct ?? 0}%`],
            ["Schedule SPI",   kpi.schedule_pct != null ? `${kpi.schedule_pct}%` : "—"],
            ["Budget used",    kpi.budget_used_pct != null ? `${kpi.budget_used_pct}%` : "—"],
            ["Quality",        kpi.quality_score != null ? `${kpi.quality_score}%` : "—"],
            ["Deliverables",   `${kpi.deliverables_completed ?? 0}/${kpi.deliverables_total ?? 0}`],
            ["Open risks",     kpi.open_risks ?? 0],
            ["Open issues",    kpi.open_issues ?? 0],
            ["Open NCRs",      kpi.open_ncrs ?? 0],
          ].map(([k, v]) => (
            <div key={k} className="rounded-md border border-slate-200 bg-white px-2.5 py-2">
              <div className="font-mono-alt text-[10px] uppercase tracking-wider text-slate-500">{k}</div>
              <div className="mt-0.5 font-display text-base font-bold text-slate-900 tabular-nums">{v}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
